module.exports = __webpack_public_path__ + "img/shot_tx20022501.c56e437c.jpg";